import React from "react";
import { Chip } from "@mui/material";
import { rotuloStatus } from "./utils";

const ESTILOS = {
    G: {
        color: "#00acc1",
        backgroundColor: "rgba(0, 188, 212, 0.1)"
    },
    C: {
        color: "#00838f",
        backgroundColor: "rgba(0, 131, 143, 0.1)"
    },
    I: {
        color: "#2e7d32",
        backgroundColor: "rgba(46, 125, 50, 0.1)"
    },
    X: {
        color: "#8d6e63",
        backgroundColor: "rgba(141, 110, 99, 0.1)"
    },
    default: {
        color: "#78909c",
        backgroundColor: "rgba(120, 144, 156, 0.1)"
    }
};

const BadgeStatusIntegracao = ({ status }) => (
    <Chip
        size="small"
        label={rotuloStatus(status)}
        sx={{
            fontWeight: 600,
            borderRadius: "999px",
            ...(ESTILOS[status] || ESTILOS.default)
        }}
    />
);

export default React.memo(BadgeStatusIntegracao);
